import { ViewRoute } from "./types";
import { RouteNames } from "@dcc/router/definitions";

export const DrinksPerWeekDayRoute: ViewRoute = {
  [RouteNames.drinksPerWeekDay]: () => {
    return RouteNames.singleOccasion;
  }
};
